import React, { Component, Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import AppContext from "../../../contexts/AppContext";
import Billing from "./Billing";
import Coupon from "./Coupon";
import Card from "./Card";
import { processCheckout } from "../../../services/checkout";

export class CheckoutForm extends Component {
	state = {
        item: {
			fname: '',
			lname: '',
			email: localStorage.getItem('subscriber_email') !== null || localStorage.getItem('subscriber_email') !== undefined ? localStorage.getItem('subscriber_email') : '',
			address: '',
			city: '',
			province: '',
			zip: '',
			country: '',
			coupon: '',
			number: '',
			expiration_year: '',
			expiration_month: '',
			cvc: '',
			agree: false,
			cpn_call: '0',
        },
		errors: {},
		loading: false,
	};
	selectCountry = val => {
		let temp = this.state.item;
        temp['country'] = val;	
		let error = this.state.errors;
        error['country'] = null;
        this.setState({ item: temp, errors: error });
	}
	
	selectRegion = val => {
		let temp = this.state.item;
        temp['province'] = val;	
		let error = this.state.errors;
        error['province'] = null;
        this.setState({ item: temp, errors: error });
	}
	
	onChange = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;		
        let error = this.state.errors;
        error[field.target.name] = null;
        this.setState({ item: temp, errors: error });
	};

	handleCheckboxChange = () => {
		let temp = this.state.item;
		temp['agree'] = !temp.agree;
		let error = this.state.errors;
		error['agree'] = !temp.agree ? "Please agree to our terms and conditions." : null;    
		this.setState({ item: temp, errors: error });
	}

	handleValidation = () => {
        let fields = this.state.item;
        let errors = {};		
        let formIsValid = true;       

        if(!fields.fname){
            formIsValid = false;
            errors.fname = "The first name field is required.";
		}  
		if(!fields.lname){
            formIsValid = false;
            errors.lname = "The last name field is required.";
		} 
		if(!fields.email){
            formIsValid = false;
            errors.email = "The email field is required.";
		} 
		if(!fields.address){
            formIsValid = false;
            errors.address = "The address field is required.";
		} 
		if(!fields.city){
            formIsValid = false;
            errors.city = "The city field is required.";
		} 
		if(!fields.province){
            formIsValid = false;
            errors.province = "The state field is required.";
		} 
		if(!fields.zip){
            formIsValid = false;
            errors.zip = "The zip field is required.";
		} 
		if(!fields.country){
            formIsValid = false;
            errors.country = "The country field is required.";
		}   
		
		if(!fields.number){
            formIsValid = false;
            errors.number = "The number field is required.";
		}   
		if(!fields.expiration_year){
            formIsValid = false;
            errors.expiration_year = "The expiration year field is required.";
		}  
		if(!fields.expiration_month){
            formIsValid = false;
            errors.expiration_month = "The expiration month field is required.";
		}  
		if(!fields.cvc){
            formIsValid = false;
            errors.cvc = "The cvv field is required.";
		}  
		
		if(!fields.agree){
            formIsValid = false;
            errors.agree = "Please agree to our terms and conditions.";
        }  
		errors['coupon'] = ''; 	
        this.setState({errors: errors});        
        return formIsValid;
    } 
	processCheckout = e => {
		e.preventDefault();
		if(this.handleValidation())
		{
			this.setState({loading: true});  
			processCheckout(this.state.item)
            .then(res => {
				this.setState({loading: false}); 
				//this.context.state.showCodeMessage(res.message,'success');   
				localStorage.removeItem("subscriber_email"); 
                //localStorage.setItem("auth_token", res.meta.token);
                localStorage.setItem("user", JSON.stringify(res.data));
                if (res.meta.token) {
					this.props.history.push('/process/account-details/' + res.meta.token);
					//window.location = '/account-details/' + res.meta.token;                    
                }
            })
            .catch(error => {
				this.setState({loading: false}); 
				//this.context.state.showCodeMessage('Something went wrong..','error');
                switch (error.response.status) {
                    case 422:
                        if(error.response.data.hasOwnProperty("errors"))
                        {
                            this.setState({ errors: error.response.data.errors });
                        }
                        else
                        {
                            this.setState({ errors: error.response.data.error });
                        }
                        
                        break;
                    default:
                        this.context.state.handelError(error);
                        break;
                }
            });   
		}		
	}

	render() {
        return (
		    <Fragment>
                <form onSubmit={this.processCheckout}>
			        <Billing errs={this.state.errors} item={this.state.item} onChangeHandlerFn={this.onChange} selectRegion={this.selectRegion} selectCountry={this.selectCountry}></Billing>
					<Coupon errs={this.state.errors} item={this.state.item} onChangeHandlerFn={this.onChange}></Coupon>
					<Card errs={this.state.errors} item={this.state.item} onChangeHandlerFn={this.onChange}></Card>
					<div className="row">
					    <div className="col-12">
					        <div className="custom-control custom-checkbox pl-5">
                              <input type="checkbox" onChange={this.handleCheckboxChange} checked={this.state.item.agree} className="custom-control-input"  name="agree" id="customCheck" name="example1"/>
                              <label className="custom-control-label" htmlFor="customCheck">I have read and agree to the website's <a href="https://www.iubenda.com/privacy-policy/72278847" target="_blank">Terms and Conditions.</a></label>
							  {this.state.errors.agree ? (
								<div className="invalid-feedback">
									{this.state.errors.agree}
								</div>
							) : null} 
                            </div>
						</div>
                        <div className="col-12 my-4">
						    <small className="special text-muted">To avoid being charged the recurring price stated above, you must cancel your subscription before the next billing date.</small>
						</div>
						<div className={this.props.mobileButtonVisible ? "col-12 sticky-order open" : "col-12"}>
						    <button type="submit" disabled={this.state.loading}  className="btn btn-primary border-0"><i className={this.state.loading ? `mr-2 fas fa-spinner fa-spin` : `mr-2 fas fa-shield-alt`}></i> {this.state.loading ? `Processing...` : `Get Started`}</button>
						</div>
					</div>	
			    </form>
			</Fragment>
		);
        
    }
}

CheckoutForm.contextType = AppContext;
export default withRouter(CheckoutForm);


// WEBPACK FOOTER //
// ./src/components/general/include/CheckoutForm.js